export const appName = 'Tranfoo'

// local storage keys
export const storageKeys = {
  userId: 'curr_user_id',
  userId2: 'curr_user_id2',
  language: 'preferred_language'
}

// database table names
export const tables = {
  users: `users`,
  projects: `projects`,
  auths: `auths`,
  databases: `databases`,
  storages: `storages`,
  functions: `functions`,
  files: `files`,
  ai: `AI_data`,
}

export const storages = {
  userFiles: 'user_files',
}

// plan limits
export const freeLimits = {
  projects: 1,
  users: 50,
  databases: 2,
  totalDataSpace: 10485760, // 10 MB
  storage: 104857600, // 100 MB
  functions: 5,
  functionSize: 10240, // 10 KB
  aiAccessTimes: 10,
  apiCalls: 5000,
}
export const proLimits = {
  projects: 10,
  users: 1000000,
  databases: 1000,
  functions: 9999999, // unlimited
  functionSize: 51200, // 50 KB
  totalDataSpace: 10737418240, // 10 GB
  storage: 21474836480, // 20 GB
  apiCalls: 1000000
}

// languages map
export const languages = {
  'en-US': 'English',
  'zh-TW': '中文 (繁體)',
}

export const MAX_IMAGE_SIZE = 2048 * 2048;

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];